import { type AppInfo } from '../../../types';
import { useTranslation } from '../../../i18n/i18n';
import { useAnotherApp } from '../../../hooks/useEmbeddedCopy';
import EmbeddedStatusScreen from './StatusScreen';

/** Redirect apps and pairing codes have no embedded screens yet. */
export default function EmbeddedUnsupportedScreen({
  app,
  onBack,
}: {
  app?: AppInfo;
  onBack?: () => void;
}) {
  const { t } = useTranslation();
  return (
    <EmbeddedStatusScreen
      visual="app"
      app={app}
      badge="x"
      title={t('embedded.unsupported.title', { app: app?.name ?? '' })}
      sub={t('embedded.unsupported.sub')}
      secondary={useAnotherApp(onBack)}
    />
  );
}
